import { render, staticRenderFns } from "./TextAreaEditor.vue?vue&type=template&id=8479de62&scoped=true&"
import script from "./TextAreaEditor.vue?vue&type=script&lang=ts&"
export * from "./TextAreaEditor.vue?vue&type=script&lang=ts&"
import style0 from "./TextAreaEditor.vue?vue&type=style&index=0&id=8479de62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8479de62",
  null
  
)

export default component.exports